import { useQuery } from "@apollo/client";
import { GET_MEDIA_ITEM_BY_SLUG } from "../queries";
import { saveToLocalStorage } from "./localStorage";

const useMediaItem = (slug) => {

  const { loading, error, data } = useQuery(GET_MEDIA_ITEM_BY_SLUG, { 
    variables: { slug },
    onCompleted: (fetchedData) => {
      saveToLocalStorage(slug, fetchedData);
    },
  });
  return { loading, error, data };
};

export default useMediaItem;
